import { READ_ONLY_MODE } from "Areas/Documents/documentDetails/types/readOnlyMode";
import Menu from "Components/menu";
import get from "lodash/get";
import isNil from "lodash/isNil";
import map from "lodash/map";
import React, { useCallback, useEffect, useMemo } from "react";
import { ITEM_SIZES, NAV_ITEM_ACTION_PANEL_CLASS_NAME } from "../../Common";
import buildDocumentActionsMenuItems from "../utils/buildDocumentActionsMenuItems";
import buildDocumentSidebarItems, { buildDocumentKey } from "../utils/buildDocumentSidebarItems";
import { FloatSidebarMenuList } from "Areas/Sidebar/Common/floatSidebarMenuList";
import { SORT_ORDER } from "Common/dictionaries/sortOrder";
import { Button } from "UiKit";
import styles from "./tabDocuments.module.css";
export default function TabDocuments(props) {
    useEffect(() => {
        props.projectId && props.onInitialized && props.onInitialized(props.projectId);
    }, [props.onInitialized, props.projectId]);
    const sidebarMenuItems = useMemo(() => buildDocumentSidebarItems(props.documents, (document) => (React.createElement(Menu, { key: "menu", togglerClassName: "no-border no-default-colors animate-hover-color", togglerIconClassName: "icon-dots", togglerWidth: ITEM_SIZES.MIN_ACTION_ELEMENT_SIZE, togglerHeight: ITEM_SIZES.MIN_ACTION_ELEMENT_SIZE, items: buildDocumentActionsMenuItems(props.projectId, document, props.onOpenDocumentEditorPanel, props.onDeleteDocument, props.onSetDocumentSelected, props.canOpen, props.canEditDocuments, props.canDeleteDocuments) }))), [
        props.projectId,
        props.documents,
        props.onOpenDocumentEditorPanel,
        props.onDeleteDocument,
        props.onSetDocumentSelected
    ]);
    const selectedItems = useMemo(() => new Set(map(props.selectedDocumentIds, buildDocumentKey)), [props.selectedDocumentIds]);
    const activeItems = useMemo(() => new Set(props.activeDocumentId ? [buildDocumentKey(props.activeDocumentId)] : []), [props.activeDocumentId]);
    const handleItemDoubleClick = useCallback((item, evt) => {
        if (item.sourceData &&
            !isNil(props.projectId) &&
            props.onSetDocumentSelected &&
            props.canOpen &&
            props.canOpen(item.sourceData.Id, props.projectId)) {
            const target = get(evt, "event.originalEvent.currentTarget", get(evt, "currentTarget"));
            if (target && target.closest(`.${NAV_ITEM_ACTION_PANEL_CLASS_NAME}`))
                return;
            props.onSetDocumentSelected(item.sourceData.Id, true, item.selected ? undefined : READ_ONLY_MODE.AUTO);
        }
    }, [props.projectId, props.onSetDocumentSelected, props.canOpen]);
    useEffect(() => {
        if (props.selectedDocumentIds &&
            props.selectedDocumentIds.length === 0 &&
            props.documents &&
            props.documents.length > 0 &&
            props.onSetDocumentSelected) {
            const sortedDocuments = [...props.documents].sort((a, b) => {
                const aValue = a.Name;
                const bValue = b.Name;
                if (props.sortOrder === "asc") {
                    return aValue > bValue ? 1 : -1;
                }
                return aValue < bValue ? 1 : -1;
            });
            const firstDocument = sortedDocuments[0];
            props.onSetDocumentSelected(firstDocument.Id, true, READ_ONLY_MODE.AUTO);
        }
    }, [props.selectedDocumentIds, props.documents, props.onSetDocumentSelected]);
    const addDocument = () => {
        var _a;
        !isNil(props.projectId) && ((_a = props.onOpenDocumentCreatorPanel) === null || _a === void 0 ? void 0 : _a.call(props, props.projectId));
    };
    const header = () => (React.createElement("div", { className: styles.header },
        React.createElement("span", { className: styles.title }, "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B"),
        React.createElement(Button, { iconOnly: true, size: "28", styleType: "text", onClick: addDocument },
            React.createElement("i", { className: "icon-add" }))));
    return (React.createElement(FloatSidebarMenuList, { inProgress: !props.documents ? props.inProgress : false, sidebarMenuItems: sidebarMenuItems, selectedItems: selectedItems, activeItems: activeItems, onItemDoubleClick: handleItemDoubleClick, sortBy: "Type", sortOrder: SORT_ORDER.ASC, header: header }));
}
